import { useState } from 'react';
import Swal from 'sweetalert2';
import EventService from 'src/services/api/eventService';
import { errorInput } from 'src/components/helpers';
import { buildServicePayload, getEffectiveSlugname, isPaidService } from '../serviceFormUtils';

const MANDATORY_INPUTS = ['capacity', 'date', 'time'];

const useServiceForm = ({ initialInputs = {}, eventId } = {}) => {
  const [inputs, setInputs] = useState(initialInputs);
  const [errorInputs, set_errorInputs] = useState({});
  const [loading, set_loading] = useState(false);

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const selectHandle = (e, { name, value }) => {
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const updateInputs = (changes) => {
    setInputs((prev) => ({ ...prev, ...changes }));
  };

  const verifyForm = () => {
    let errors = {};

    MANDATORY_INPUTS.forEach((name) => {
      errors = errorInput({ errorInputs: errors, input: { name, value: inputs[name] } });
    });
    errors = errorInput({
      errorInputs: errors,
      input: { name: 'eventSlugname', value: getEffectiveSlugname(inputs) },
    });

    if (isPaidService(inputs)) {
      errors = errorInput({
        errorInputs: errors,
        input: { name: 'paidEvent', value: inputs.paidEvent },
      });
    }

    if (inputs.extraInfo) {
      (inputs.extraQuestions || []).forEach((question) => {
        errors[question.id] = !question.label?.trim();
      });
    }

    set_errorInputs(errors);
    return Object.values(errors).includes(true);
  };

  const submit = async () => {
    if (verifyForm()) return null;
    set_loading(true);

    const body = buildServicePayload(inputs, eventId);

    try {
      const response = eventId
        ? await EventService.editEvent(body)
        : await EventService.createEvent(body);
      if (!response.data.success) {
        Swal.fire(response.data.message || 'Algo falló, intenta de nuevo.');
        return null;
      }
      return { body, message: response.data.message };
    } catch (err) {
      Swal.fire(err?.response?.data?.message || 'Algo falló, intenta de nuevo.');
      return null;
    } finally {
      set_loading(false);
    }
  };

  return {
    inputs,
    setInputs,
    updateInputs,
    handleInputs,
    selectHandle,
    errorInputs,
    hasErrors: Object.values(errorInputs).includes(true),
    loading,
    submit,
  };
};

export default useServiceForm;
